// Worked examples for the Learning Backlog. Illustrative: an invented startup's open
// questions during customer discovery. Addressable as #example=<id>.

import { methodById } from "../learning/methods.js";

const q = (label, low, high, preset, days) => {
  const m = methodById(preset);
  return { label, value: { low, high }, preset, noise: m.noise, bias: m.bias, days };
};

export const EXAMPLES = [
  {
    id: "discovery",
    name: "Startup in customer discovery",
    description: "Six open questions, ten days of design and product time. Illustrative.",
    state: {
      unit: "€k",
      dayValue: 0.6,
      budget: 10,
      questions: [
        q("Will teams pay for a team plan?", -30, 60, "fake-door", 2),
        q("Is self-serve onboarding enough?", -10, 40, "prototype", 2),
        q("Do users want a mobile app?", -40, 30, "interviews", 4),
        q("Usage-based pricing", -20, 25, "interviews", 4),
        q("CSV export", 4, 12, "interviews", 3),
        q("Slack integration", -5, 15, "beta", 8),
      ],
    },
  },
  {
    id: "no-ab-platform",
    name: "Growth team without an A/B platform",
    description: "Random rollouts by account and before/after reads. Illustrative.",
    state: {
      unit: "€k",
      dayValue: 0.8,
      budget: 8,
      questions: [
        q("New pricing page", -15, 30, "staged-random", 4),
        q("Shorter signup form", -5, 20, "before-after", 1),
        q("Annual plan discount", -20, 20, "staged-random", 5),
        q("Referral programme", -10, 25, "fake-door", 2),
      ],
    },
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) ?? null;
}
